import { render, staticRenderFns } from "./ModalEmissionHistory.vue?vue&type=template&id=587d2705"
import script from "./ModalEmissionHistory.vue?vue&type=script&lang=ts"
export * from "./ModalEmissionHistory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports